module.exports = __webpack_public_path__ + "static/media/Asset 10LHip.fad9f65b.png";